<app-sidebar-item
  class="rounded [&:not(.drag-over)]:hover:bg-hover"
  *nestedFor="
    let item of items;
    let index = index;
    let depth = depth;
    let expandable = expandable;
    let expanded = expanded;
    stateKey: StateKey.sheetsSidebarSheetFoldersTree + team?.id;
  "
  [title]="item.title"
  [icon]="item.icon"
  [depth]="depth + (team ? 2 : 0)"
  [expandable]="expandable"
  [expanded]="expanded.value"
  [active]="currentTeamId === team?.id && sidebarFilter === item.id"
  (onExpand)="expanded.next($event)"
  (appClick)="selectFilter(item.id)"
  [appSidebarContextMenu]="item.id"

  #elRef
  appDroppable
  appDroppableHoverClass="drag-over"
  [appDroppablePredicate]="dndPredicate"
  (appDroppableDrop)="dndDrop($event, item.id, index)"
/>

<app-sidebar-items-divider />

<app-side-bar-sheet-folders
  (selectFilter)="selectFilter($event)"
  [team]="team"
/>

<app-sidebar-items-divider />

<!-- The same Pinned Knots / Pinned Tags / Pinned Connections rows as the other apps' rails (settings report S-26). -->
<app-knowledge-items-rail
  [sidebarSplitViewKey]="sidebarSplitViewKey"
  [team]="team"
  [rowHeight]="32"
/>

<ng-template #afterDropTemplate let-item=item>
  <app-sheet-quick-form
    [autofocus]="true"
    [showMore]="true"
    [title]="item.title"
    [sheet]="item"
    (more)="handleMore($event)"
    (close)="handleClose()"
  />
</ng-template>
